import ReactiveState from '@/ui-kit/hooks/ReactiveState';
import { Pagination, PaginationDto } from '@/ui-kit/components/pagination-navigator/entities/Pagination';

interface GridPaginationDto extends PaginationDto {
  pageNumber: number;
}

export class GridPagination extends Pagination<GridPaginationDto> {
  protected reactiveState: ReactiveState<GridPaginationDto>;

  constructor({
    pageNumber = 0,
    pageSize = 0,
    totalItems = 0,
  }: GridPaginationDto) {
    super();
    this.reactiveState = new ReactiveState({
      pageNumber,
      pageSize,
      totalItems,
    });
  }

  get pageNumber(): number {
    return this.reactiveState.value.pageNumber;
  }

  get firstIndexOnPage(): number {
    return (this.pageSize * this.pageNumber) - this.pageSize + 1;
  }

  get lastIndexOnPage(): number {
    return this.pageSize * this.pageNumber > this.totalItems
      ? this.totalItems
      : this.pageSize * this.pageNumber;
  }

  get pagesAmount(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  setPageNumber(pageNumber: number): void {
    this.setOptions({ pageNumber });
  }

  setPreviousPage(): void {
    this.setPageNumber(this.pageNumber - 1);
  }

  setNextPage(): void {
    this.setPageNumber(this.pageNumber + 1);
  }
}
